import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d13c054"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model__wrapper" }

import { TProduct } from '@/const/types/product';
import { BasicImage, BasicAttributesList, BasicModelBasicInfoList } from '@components/basic'
import { TCombination } from '@/const/types/combination';
import { TDocument } from '@/const/types/documents';
import { TPlace } from '@/const/types/place';

interface Props {
  model: TPlace | TCombination | TProduct | TDocument;
  modelName: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicModelDetailsList',
  props: {
    model: null,
    modelName: null
  },
  setup(__props: any) {

const props = __props as {
  model: TPlace | TCombination | TProduct | TDocument;
  modelName: string;
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.model['image_url'])
      ? (_openBlock(), _createBlock(_unref(BasicImage), {
          key: 0,
          url: props.model['image_url']
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (__props.model.attributes)
      ? (_openBlock(), _createBlock(_unref(BasicAttributesList), {
          key: 1,
          attributes: __props.model.attributes
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.modelName) + " attributes: ", 1)
          ]),
          _: 1
        }, 8, ["attributes"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(BasicModelBasicInfoList), {
      model: props.model,
      modelName: props.modelName
    }, null, 8, ["model", "modelName"]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})